@file:UseSerializers(InstantAsEpochMillis::class)
package net.frozenbit.games.soundgame.dtos

import kotlinx.serialization.Serializable
import kotlinx.serialization.UseSerializers
import net.frozenbit.games.soundgame.dtos.serializers.InstantAsEpochMillis
import kotlin.time.Instant

@Serializable
sealed interface ControllerServerMessage

@Serializable
data object ControllerIdleUpdate : ControllerServerMessage

@Serializable
data class ControllerDisconnect(
    val reason: String,
) : ControllerServerMessage

@Serializable
data class ControllerLobbyUpdate(
    val common: CommonControllerGameData,
    val currentAvatarIndex: Int,
    val showAdminControls: Boolean,
    val enableStartButton: Boolean,
) : ControllerServerMessage

@Serializable
data class ControllerWaitUpdate(
    val common: CommonControllerGameData,
) : ControllerServerMessage

@Serializable
data class ControllerPromptSelectionUpdate(
    val common: CommonControllerGameData,
    val optionTexts: List<String>,
    val startedAt: Instant,
    val expiresAt: Instant,
) : ControllerServerMessage

@Serializable
data class ControllerSoundSelectionUpdate(
    val common: CommonControllerGameData,
    val optionTexts: List<String>,
    val picks: List<Int>,
    val startedAt: Instant,
    val expiresAt: Instant,
    /**
     * If not null, indicates the time at which the player can no longer change their sound picks
     */
    val lockIn: WsTimeout?,
) : ControllerServerMessage

@Serializable
data class ControllerVotingUpdate(
    val common: CommonControllerGameData,
    val options: List<Creation>,
    val startedAt: Instant,
    val expiresAt: Instant,
) : ControllerServerMessage {
    @Serializable
    data class Creation(
        val sound1Title: String,
        val sound2Title: String,
    )
}

@Serializable
data class ControllerGameOverUpdate(
    val common: CommonControllerGameData,
    val buttons: List<String>,
) : ControllerServerMessage

@Serializable
data class CommonControllerGameData(
    val sessionId: String,
    val serverTime: Instant,
)

@Serializable
data class WsTimeout(
    val start: Instant,
    val end: Instant,
)